export const services = [
  {
    id: "crochet",
    title: "Crochet",
    tagline: "Loop by loop — a calm, creative flow.",
    image: "https://images.unsplash.com/photo-1668072587992-7c0d529d5363?w=1200&q=80",
    summary:
      "Gentle, hands-on crochet sessions run in a warm, judgement-free space. Beginners welcome — we bring the hooks, yarn and cuppas.",
    highlights: [
      "1-on-1 or small group sessions",
      "All abilities and skill levels welcome",
      "Take home a project you're proud of",
      "Improves focus, dexterity and confidence",
    ],
    what_to_expect:
      "Sessions start with a warm welcome and a chat. Your support worker helps you choose a project (a scarf, a granny square, an amigurumi friend) and works alongside you at your pace. No rush, no pressure — just yarn, laughs and a bit of mindful making.",
  },
  {
    id: "painting",
    title: "Painting",
    tagline: "Colour on your terms.",
    image: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=1200&q=80",
    summary:
      "Acrylics, watercolours, mixed media — painting classes designed for NDIS participants of every ability.",
    highlights: [
      "Adaptive tools and grips available",
      "Structured or free-flow sessions",
      "Regular showcase of participant art",
      "Explore emotion, memory and story through colour",
    ],
    what_to_expect:
      "Every session begins with your idea. We help you sketch it, mix the colours, and put paint to canvas. Whether you like abstract splashes or careful landscapes, we meet you where you are and celebrate every brushstroke.",
  },
  {
    id: "daily-living",
    title: "Daily Living",
    tagline: "The everyday skills that build independence.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200&q=80",
    summary:
      "Practical, patient support with the everyday tasks that make a home feel like home — cooking, cleaning, shopping and budgeting.",
    highlights: [
      "Cooking simple, healthy meals together",
      "Household routines and cleaning skills",
      "Grocery planning and shopping trips",
      "Budgeting and money management basics",
    ],
    what_to_expect:
      "We come alongside you in your own home or in the community. Nothing is done for you unless you want it to be — instead we build habits, confidence and independence, one small win at a time.",
  },
  {
    id: "craft",
    title: "Craft",
    tagline: "Make something with your hands. Feel it in your heart.",
    image: "https://images.unsplash.com/photo-1506806732259-39c2d0268443?w=1200&q=80",
    summary:
      "From upcycling to card-making to seasonal projects — our craft workshops are social, sensory and full of surprises.",
    highlights: [
      "Weekly rotating projects",
      "Sensory-friendly materials",
      "Group setting for social connection",
      "All supplies included",
    ],
    what_to_expect:
      "You'll join a small, welcoming group in our craft space. Each week we tackle a fresh project — themed around the season, an upcoming event, or a request from participants. The vibe is warm, chatty and unhurried.",
  },
  {
    id: "finding-friends",
    title: "Finding Friends",
    tagline: "Real connection, at your own pace.",
    image: "https://customer-assets.emergentagent.com/job_peerwave-landing/artifacts/lgqdg3zj_hot%20tub.jpg",
    summary:
      "Social groups, buddy meet-ups and outings designed to help you build genuine friendships in the Fraser Coast community.",
    highlights: [
      "Small, supported social groups",
      "Regular community outings",
      "1-on-1 buddy matching",
      "Zero pressure, all warmth",
    ],
    what_to_expect:
      "Loneliness is real, and it's not your fault. We help you find your people — through shared interests, coffee catch-ups, beach walks and community events. You choose the pace, we bring the safety net.",
  },
  {
    id: "finding-work",
    title: "Finding Work",
    tagline: "A working life that fits who you are.",
    image: "https://customer-assets.emergentagent.com/job_peerwave-landing/artifacts/pjgkqhjc_work.jpg",
    summary:
      "Employment support that respects your interests, strengths and rhythm — from first resume to first pay cheque.",
    highlights: [
      "Strengths-based career discovery",
      "Resume writing and interview practice",
      "On-the-job coaching and check-ins",
      "Employer education and workplace advocacy",
    ],
    what_to_expect:
      "We start with what you love and what you're good at. Then we map a realistic, kind path towards paid work, volunteer roles or micro-enterprise — with a real person beside you every step of the way.",
  },
];

export const getService = (id) => services.find((s) => s.id === id);
